module.exports = __webpack_public_path__ + "assets/img/multiple-attempts.bd7628a3.jpeg";